import { HttpResponse } from '@angular/common/http';
import { Component, inject, input } from '@angular/core';
import {
	ApiPaginatedResponse,
	ApiRequestOrdering,
	ApiRequestPagination,
	DataExportFormatEnum,
	VehicleInsuranceSearchDto,
	VehicleInsurancesFilters,
	ModulesEnum,
	VehicleInsurancesStatsDto,
} from '@splitsecondconnect/ultramarine-shared';
import { Observable } from 'rxjs';

import { FiltersConfig } from '../../../../shared/models/filters-config';
import { ListStrategy } from '../../../../shared/models/list-strategy';
import { SelectItem } from '../../../../shared/models/select-item.type';
import { VehicleInsurancesListItemMenuComponent } from '../components/vehicle-insurances-list-item-menu/vehicle-insurances-list-item-menu.component';
import { mapDtoToModelVehicleInsurances } from '../mappers/search-dto-to-model.mapper';
import { VehicleInsurancesSectionItemComponent } from '../sections/vehicle-insurances-section-item/vehicle-insurances-section-item.component';
import { VehicleInsurancesService } from '../vehicle-insurances.service';

import { getVehicleInsuranceFilters } from './vehicle-insurance-filters.config';

@Component({
	selector: 'app-vehicle-insurance-list-selected-item',
	imports: [VehicleInsurancesSectionItemComponent],
	host: {
		class: 'w-full',
	},
	template: `
		<app-vehicle-insurances-section-item [plain]="plain()" [item]="item()" />
	`,
})
class VehicleInsuranceListItemComponent {
	item = input<SelectItem<VehicleInsuranceSearchDto>>();
	plain = input<boolean>();
	moduleEnum = ModulesEnum;
}

export class VehicleInsuranceListStrategy implements ListStrategy<
	VehicleInsurancesFilters,
	VehicleInsuranceSearchDto,
	VehicleInsurancesStatsDto
> {
	module = ModulesEnum.VEHICLE_INSURANCES;
	#service = inject(VehicleInsurancesService);
	component: any = VehicleInsuranceListItemComponent;
	componentMenu: any = VehicleInsurancesListItemMenuComponent;
	ordering: ApiRequestOrdering = {
		columnName: `vehicle_insurance.id`,
		direction: 'DESC',
	};

	mapDtoToModel(
		vehicleInsurances: VehicleInsuranceSearchDto[],
	): SelectItem<VehicleInsuranceSearchDto>[] {
		return mapDtoToModelVehicleInsurances(vehicleInsurances);
	}

	getStats() {
		return this.#service.getStats();
	}

	getSearchResults(
		searchQuery: string,
		searchQueryIds: number[],
		pageSize: number,
		searchFilters: VehicleInsurancesFilters,
		page: number,
		ordering: ApiRequestOrdering,
	): Observable<ApiPaginatedResponse<VehicleInsuranceSearchDto[]>> {
		return this.#service.getSearchResults(
			searchQuery,
			searchQueryIds,
			pageSize,
			searchFilters,
			page,
			ordering,
		);
	}

	exportList(
		format: DataExportFormatEnum,
		options: object,
		searchQueryIds: number[],
		searchFilters?: VehicleInsurancesFilters,
		searchQuery?: string,
		pagination?: ApiRequestPagination,
		ordering?: ApiRequestOrdering,
	): Observable<HttpResponse<Blob>> {
		return this.#service.exportList(
			searchFilters,
			searchQuery,
			searchQueryIds,
			pagination,
			ordering,
			format,
			options,
		);
	}

	clearFilters() {
		this.#service.resetVehicleInsurancesFilters();
	}

	getFiltersConfig(): FiltersConfig[] {
		return getVehicleInsuranceFilters();
	}

	filtersObject: VehicleInsurancesFilters = this.#service.filtersObject;

	filterSubjects: any = this.#service.vehicleInsurancesFilters;
}
